import React from "react";

import { TemplateSelectorsSourceField } from "../../../../../../../../components/fields/TemplateSelectorsSourceField";
import { TemplateSelectorsConditionField } from "../../../../../../../../components/fields/TemplateSelectorsConditionField";
import { TemplateSelectorsTypesField } from "../../../../../../../../components/fields/TemplateSelectorsTypesField";
import { TextField } from "../../../../../../../../components/forms/fields";

const TemplateSelectorFormFields = () => (
    <>
        <TemplateSelectorsSourceField isMenuPortal/>

        <TemplateSelectorsConditionField isMenuPortal/>

        <TemplateSelectorsTypesField isMenuPortal/>

        <TextField
            name="selector"
            label="Selector"
            placeholder="Selector"
        />
    </>
);

export default TemplateSelectorFormFields;
